import { Box, customStyled } from '@mafc/trolly';

export const Shipment = customStyled(Box)(props => ({
  marginBottom: props.theme.space[5],
}));
